import type { ReactNode } from 'react';

import { CalendarDaysIcon } from '@heroicons/react/20/solid';

interface Props {
  decisionDate: string;
  decisionDateOptions: string[];
  onChangeDecisionDate: (d: string) => void;
  // Reorder editor for the selected policy — rendered below the decision date.
  policySelector: ReactNode;
}

const labelCls = 'text-[11px] font-semibold uppercase tracking-wide text-gray-500';

// Decision date (the scenario lever) plus the selected policy's reorder editor.
// Built to add more levers (on-hand, in-flight, demand projection) later.
export function ScenarioControlsBar({
  decisionDate,
  decisionDateOptions,
  onChangeDecisionDate,
  policySelector,
}: Props) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-gray-100 px-4 py-3">
        <span className="flex items-center gap-1.5">
          <span className={labelCls}>Decision date</span>
          <CalendarDaysIcon className="h-4 w-4 shrink-0 text-gray-400" />
          <select
            value={decisionDate}
            onChange={(e) => onChangeDecisionDate(e.target.value)}
            className="rounded-md border border-gray-300 bg-white px-2.5 py-1 font-mono text-xs text-gray-700 focus:border-[#274483] focus:ring-1 focus:ring-[#274483]"
          >
            {decisionDateOptions.includes(decisionDate) ? null : <option value={decisionDate}>{decisionDate}</option>}
            {decisionDateOptions.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </span>
      </div>

      <div className="px-4 py-3">{policySelector}</div>
    </div>
  );
}
